import { defineComponent as C, useSlots as w, computed as s, useAttrs as A, createElementBlock as r, openBlock as a, normalizeClass as N, createBlock as T, createVNode as _, resolveDynamicComponent as R, mergeProps as S, withCtx as V, renderSlot as D, createCommentVNode as m, toDisplayString as f, unref as i } from "vue";
import { RevButtonBase as d } from "@ds/components/ButtonBase";
import { RevButtonIcon as I } from "@ds/components/ButtonIcon";
import { usePropsValidation as P } from "../../composables/usePropsValidation.js";
import $ from "../../icons/generated/IconCross.vue2.js";
import { useI18n as j } from "@ds/plugin";
import z from "../../translations/generic.translations.js";
import { tw as e } from "../../utils/tailwind.js";
const E = {
  key: 0,
  class: "body-2 pr-4"
}, q = {
  key: 1,
  class: "group-focus-visible-outline-default-hi rounded-sm body-2-link"
}, Q = /* @__PURE__ */ C({
  name: "RevBanner",
  inheritAttrs: !1,
  __name: "Banner",
  props: {
    closeAlternativeText: {},
    cta: {},
    label: {},
    to: {}
  },
  emits: ["close"],
  setup(n, { emit: p }) {
    const t = n, v = p, b = w();
    P({
      "please, provide either props.label or a default slot": () => !b.default && !t.label
    });
    const h = s(() => {
      const o = e`bg-static-info-hi flex w-full items-center justify-center`, u = [
        e`cursor-pointer`,
        e`focus-within:bg-static-info-hi-hover hover:bg-static-info-hi-hover`,
        e`focus-within:no-underline hover:no-underline`,
        e`motion-safe:transition motion-safe:duration-200 motion-safe:ease-in`
      ];
      return t.to ? [o, u] : o;
    }), g = s(() => [
      e`text-action-default-hi group flex-1 py-16 pl-24 text-left leading-none no-underline md:p-16 md:text-center`,
      t.cta && e`outline-none`,
      !t.cta && e`focus-visible-outline-default-hi`
    ]), l = s(() => t.to ? d : "div"), c = A(), x = s(() => l.value === d ? {
      ...c,
      to: t.to
    } : c);
    function y(o) {
      v("close", o);
    }
    const B = j(), k = t.closeAlternativeText || B(z.buttonClose);
    return (o, u) => (a(), r("aside", {
      class: N(h.value)
    }, [
      (a(), T(R(l.value), S({ class: g.value }, x.value), {
        default: V(() => [
          D(o.$slots, "default"),
          n.label ? (a(), r("span", E, f(n.label), 1)) : m("", !0),
          n.cta ? (a(), r("span", q, f(n.cta), 1)) : m("", !0)
        ]),
        _: 3
      }, 16, ["class"])),
      _(i(I), {
        "aria-label": i(k),
        class: "mr-8",
        icon: i($),
        variant: "secondary",
        onClick: y
      }, null, 8, ["aria-label", "icon"])
    ], 2));
  }
});
export {
  Q as default
};
